import { render, staticRenderFns } from "./Conversas.vue?vue&type=template&id=efc8c56e&scoped=true"
import script from "./Conversas.vue?vue&type=script&lang=js"
export * from "./Conversas.vue?vue&type=script&lang=js"
import style0 from "./Conversas.vue?vue&type=style&index=0&id=efc8c56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc8c56e",
  null
  
)

export default component.exports